/* eslint-disable camelcase */
const es = {
  common: {
    copied: 'Copiado',
    course: {
      zero: '%{courses_capitalized}',
      one: '%{course_capitalized}',
      other: '%{courses_capitalized}'
    },
    follower: {
      zero: 'Seguidores',
      one: 'Seguidor',
      other: 'Seguidores'
    },
    leader: {
      zero: 'Líderes',
      one: 'Líder',
      other: 'Líderes'
    }
  },
  joi: {
    fields: {
      date_of_birth: 'Fecha de nacimiento',
      email: 'Correo electrónico',
      partner_email: 'Correo electrónico del compañero',
      first_name: 'Nombre',
      last_name: 'Apellido',
      phone: 'Teléfono',
      student: '%{member_capitalized}',
      role: 'Rol',
      partner_gegevens: 'Detalles del compañero',
      woonplaats: 'Ciudad',
      hoe_heb_je_ons_gevonden: '¿Cómo nos encontraste?',
      fields_name: 'Nombre del campo',
      fields_id: 'ID del campo',
      fields_type: 'Tipo de campo',
      fields_mandatory: 'Obligatorio',
      fields_category: 'Categoría',
      fields_value: '%{name}',
    },
    templates: {
      base: '%{field} %{message}'
    },
    string: {
      base: 'debe ser una cadena.',
      empty: 'no puede estar vacío',
      min: 'debe contener al menos %{number} caracteres.',
      max: 'debe contener como máximo %{number} caracteres.',
      length: 'no tiene la longitud exacta especificada.',
      email: 'no es un correo electrónico válido.',
      regex: {
        base: 'no coincide con la expresión regular especificada.'
      },
      restricted_email: 'del compañero no puede ser el mismo que el del comprador.',
      invalid_email: 'es inválido.'
    },
    number: {
      base: 'debe ser un número.',
      min: 'es menor que el mínimo especificado.',
      max: 'es mayor que el máximo especificado.',
      integer: 'no es un número entero.'
    },
    date: {
      base: 'no es una fecha válida.',
      min: 'es anterior a la fecha mínima especificada.',
      max: 'es posterior a la fecha máxima especificada.'
    },
    boolean: {
      base: 'debe ser un valor booleano.'
    },
    array: {
      base: 'debe ser una lista.',
      min: 'tiene menos elementos que el mínimo especificado.',
      max: 'tiene más elementos que el máximo especificado.'
    },
    object: {
      base: 'debe ser un objeto.',
      unknown: 'contiene campos no permitidos.'
    },
    any: {
      invalid: 'contiene un token inválido.',
      required: 'no fue proporcionado.',
      only: 'no coincide con ninguno de los valores permitidos.'
    }
  },
  installments: {
    delete_failed: 'No se pudo quitar. Inténtalo de nuevo.'
  },
  mailings: {
    editor: {
      first_name: 'Nombre',
      last_name: 'Apellido',
      placeholders: 'Marcadores de posición'
    }
  },
  payment_form: {
    on_waitlist: 'En la lista de espera',
    people_waiting: {
      one: '1 persona en la lista de espera',
      other: '%{count} personas en la lista de espera'
    },
    discount_code: {
      check: 'Verificar'
    },
    payments: {
      new: {
        alerts: {
          select_bank: 'Por favor selecciona tu banco',
          select_plan: 'Por favor selecciona tu plan',
          agree_terms: 'Por favor acepta los términos'
        },
        ideal_terms: 'Acepto que se deduzcan %{amount} de mi IBAN en cada nuevo período.',
        credit_card_terms: 'Acepto que se deduzcan %{amount} de mi tarjeta de crédito en cada nuevo período.'
      }
    },
    utils: {
      texts: {
        available: 'Disponible',
        select_course: 'Selecciona %{number} %{object} que deseas seguir',
        student_explanatory: 'Por favor, agrega tus datos',
        student_explanatory_student: 'Detalles del niño (el %{member})',
        partner_explanatory: 'Por favor, agrega los datos del compañero',
        partner_explanatory_student: 'Detalles del compañero',
        spots_left: {
          zero: '0 plazas disponibles',
          one: '1 plaza disponible',
          other: '%{count} plazas disponibles'
        },
        starts_on: 'Comienza el',
        waitlist: 'Unirse a la lista de espera',
        trial_class: '%{trial_class_capitalized}',
        waitlisted: 'En este momento no es posible inscribirse como %{role1}, ' +
                    'porque intentamos mantener el equilibrio en la %{class}. ' +
                    'Una plaza estará disponible tan pronto como se inscriba un nuevo %{role2}.',
        couple_available: 'Disponible como pareja',
        couple_not_available: 'No disponible',
        couple_leader_title: 'Tus datos',
        couple_leader_explanatory: 'Introduce tus datos como Leader',
        couple_follower_title: 'Datos del compañero',
        couple_follower_explanatory: 'Introduce los datos del Follower',
      }
    },
    errors: {
      no_more_spots: 'Lo sentimos, no quedan más plazas',
      no_spots_left_for: 'Lo sentimos, no quedan plazas para %{role}',
      no_dance_class_selected: 'Por favor, selecciona al menos un %{course} o haz clic en "Elegir más tarde"'
    }
  }
};
/* eslint-enable camelcase */

export default es;
